var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZakatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_71",
    "data-name": "Group 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.936,
    height: 77.64,
    viewBox: "0 0 56.936 77.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.081,
    y1: 0.086,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 56.936,
    height: 77.64,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M49.172,0H7.764A7.767,7.767,0,0,0,0,7.764V69.876A7.767,7.767,0,0,0,7.764,77.64H49.172a7.767,7.767,0,0,0,7.764-7.764V7.764A7.767,7.767,0,0,0,49.172,0M51.76,69.876a2.589,2.589,0,0,1-2.588,2.588H7.764a2.589,2.589,0,0,1-2.588-2.588V7.764A2.589,2.589,0,0,1,7.764,5.176H49.172A2.589,2.589,0,0,1,51.76,7.764Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M36.644,3H5.588A2.589,2.589,0,0,0,3,5.588V15.94a2.589,2.589,0,0,0,2.588,2.588H36.644a2.589,2.589,0,0,0,2.588-2.588V5.588A2.589,2.589,0,0,0,36.644,3M34.056,13.352H8.176V8.176h25.88ZM10.764,28.88H5.588a2.588,2.588,0,1,0,0,5.176h5.176a2.588,2.588,0,1,0,0-5.176m12.94,0H18.528a2.588,2.588,0,1,0,0,5.176H23.7a2.588,2.588,0,1,0,0-5.176m12.94,0H31.468a2.588,2.588,0,0,0,0,5.176h5.176a2.588,2.588,0,1,0,0-5.176M10.764,41.82H5.588a2.588,2.588,0,0,0,0,5.176h5.176a2.588,2.588,0,1,0,0-5.176m12.94,0H18.528a2.588,2.588,0,0,0,0,5.176H23.7a2.588,2.588,0,1,0,0-5.176m12.94,0H31.468a2.588,2.588,0,0,0,0,5.176h5.176a2.588,2.588,0,1,0,0-5.176M10.764,54.76H5.588a2.588,2.588,0,0,0,0,5.176h5.176a2.588,2.588,0,1,0,0-5.176m12.94,0H18.528a2.588,2.588,0,1,0,0,5.176H23.7a2.588,2.588,0,1,0,0-5.176m12.94,0H31.468a2.588,2.588,0,0,0,0,5.176h5.176a2.588,2.588,0,1,0,0-5.176",
    transform: "translate(7.352 7.352)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZakatIcon);
export default __webpack_public_path__ + "static/media/zakat_icon.825c019576d4f4edf891de986756dabc.svg";
export { ForwardRef as ReactComponent };